
import Vue from 'vue'
import Vuex from 'vuex'
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
	activetab: 1,
	stackname: '',
	received_messages_store: {},
    connected_store: false,
    stompClient:'',
    socket:'',
    messagelist:[],
    newMessage:0,
    seenmessage:0,
    idleSecondsCounter:0,
    sessioncheck:false,
    isLoading: false
  },
  getters: {
  	getconnected_store:  state => {
    	return state.connected_store
    },
  	getisLoading: state => {
    	return state.isLoading
    },
  	getstackname: state => {
    	return state.stackname
    },
    getactivetab: state => {
    	return state.activetab
    },
    getreceived_messages_store: state => {
    	return state.received_messages_store
    },
    getstompClient: state=>{
    	return state.stompClient
    },
    getmessagelist: state=>{
    	return state.messagelist
    },
    getnewMessage: state=>{
    	return state.newMessage
    },
    getseenmessage: state=>{
    	return state.seenmessage
    },
    getidleSecondsCounter: state=>{
    	return state.idleSecondsCounter
    },
    getsessioncheck: state=>{
    	return state.sessioncheck
    }
  },
  mutations: {
  	setconnected_store: (state, val)=>{
    	state.connected_store=val
    },
  	setisLoading: (state, val)=>{
    	state.isLoading=val
    },
  	setstackname: (state, val)=>{
    	state.stackname=val
    },
  	setsessioncheck: (state, val)=>{
    	state.sessioncheck=val
    },
  	setidleSecondsCounter: (state, val)=>{
    	state.idleSecondsCounter=val
    },
  	setseenmessage: (state, val)=>{
    	state.seenmessage=val
    },
  	setmessagelist: (state, obj)=>{
    	state.messagelist = [ ...state.messagelist, obj ]
    },
    setnewMessage: (state, val)=>{
    	state.newMessage=val
    },
    setactivetab: (state, tab) =>{
    	state.activetab=tab
    },
    send_mutations:(state,{ message,url}) =>{
	    if (state.stompClient && state.stompClient.connected) {
	        state.stompClient.send(url, JSON.stringify(message), {});
	    }
    },
    connect_mutations:(state) =>{
    	console.log("state.connected_store",state.connected_store)
	    if(state.connected_store==false){
	      state.socket = new SockJS("https://stackops.pre-freshmarketer.io/api/gs-guide-websocket");
	      state.stompClient = Stomp.over(state.socket);
	      var headers = {
		    };
	      state.stompClient.connect(
	        headers,
	        frame => {
	          state.connected_store = true;
	        },
	        error => {
	          console.log(error);
	          state.connected_store = false;
	        }
	      );
	  	}
    },
    subscribe_mutations:(state,topic) =>{
    	console.log("state.connected_store",state.connected_store)
    	state.stompClient.subscribe(topic, tick => {
    					var msg=""
		            	if(topic=="/topic/chats"){
		            		if(JSON.parse(tick.body).message.length<22){
                           		msg ='^'+JSON.parse(tick.body).employee+'^'+Array(2).join(" ")+'^'+JSON.parse(tick.body).date+'^'+"\n"+"*"+JSON.parse(tick.body).message+"*"+" \n"+'¡'+JSON.parse(tick.body).time+'¡'
		                      }else{
		                      	
		                        msg ='^'+JSON.parse(tick.body).employee+'^'+Array(2).join(" ")+'^'+JSON.parse(tick.body).date+'^'+"\n"+"*"+JSON.parse(tick.body).message+"*"+" \n"+'¡'+JSON.parse(tick.body).time+'¡'
		                      }
		            		state.received_messages_store={content_type:'chats_message',data: { type: 'text', author: JSON.parse(tick.body).employee , data: { text: msg } }};
		            	}
		            	if(topic=="/topic/employeechatlist"){
		            	 	state.received_messages_store={content_type:'chats_list_change'};
		            	}
		            	if(topic=="/topic/greetings"){
		            		state.received_messages_store={content_type:'stack_changes',data:{content:JSON.parse(tick.body).content}};
		            	}
		        	
		          });
    },
    disconnect_mutations:(state) =>{
    	console.log("state.connected_store",state.connected_store)
      if (state.stompClient) {
        state.stompClient.disconnect(function() {

		  })
      	}
      	var myTimerPromise = new Promise((resolve, reject) => {
                    setTimeout(() => {
                        state.socket.close()
                        resolve();
                    }, 50); 
            });
      state.connected_store = false;
    },
    tickleConnection_mutations:(state) =>{
      state.connected_store ? state.disconnect() : state.connect();
    }
  },
  actions: {
  	commitconnected_store: (context, val)=>{
  		context.commit("setisLoading",val)
  		
  	},
  	commitisLoading: (context, val)=>{
  		context.commit("setisLoading",val)
  	},
  	commitstackname: (context, val)=>{
  		context.commit("setstackname",val)
  	},
  	commitsessioncheck: (context, val)=>{
  		context.commit("setsessioncheck",val)
  	},
  	commitidleSecondsCounter: (context, val)=>{
  		context.commit("setidleSecondsCounter",val)
  	},
  	commitseenmessage: (context, val)=>{
  		context.commit("setseenmessage",val)
  	},
  	commitmessagelist: (context, val)=>{
  		context.commit("setmessagelist",val)
  	},
  	commitnewMessage: (context, val)=>{
  		context.commit("setnewMessage",val)
  	},
    commitactivetab:(context, tab) =>{
      context.commit("setactivetab", tab)
    },
    send_actions:(context, msg) =>{
    	context.commit("send_mutations", msg)
    },
    connect_actions:({commit, getters}) =>{
     	commit("connect_mutations", {getters})
    },
    subscribe_actions:(context, topic) =>{
    	context.commit("subscribe_mutations", topic)
    	//context.commit("setconnected_store",true)
    },
    disconnect_actions:(context) =>{
      context.commit("disconnect_mutations")
      context.commit("setconnected_store",false)
    },
    tickleConnection_actions:(context) =>{
      context.commit("tickleConnection_mutations")
    }
  },
  //plugins: [new VuexPersistence().plugin]
})
